import React from 'react';
import styles from './curd.module.scss';
import { KoText, KoTitle } from 'packages';
import KoIcon from '@kwapio/icons';
// import { KoButton } from 'packages';


const chartConfigs = [
  {
    id: 'order',
    label: 'Orders',
    icon: 'PlacedOutlined',
    arrow: 'ArrowLineUpFilled',
    description: '+125 today',
    value: `43,250`
  },
  {
    id: 'cancelled',
    label: 'Cancelled',
    icon: 'OrderCancelOutlined',
    color:'#FE5B65',
    arrow: 'ArrowLineDownFilled',
    description: '+125 today',
    value: `3,800`
  },
  {
    id: 'ticket',
    label: 'Ticket',
    icon: 'OrderTicketOutlined',
    color:'#15AC77',
    arrow: 'ArrowLineDownFilled',
    description: '+0 today',
    value: `7,258`
  }
];
const CustomerStatus = () => {
  return (
    <div className={styles.statusWrapper}>
      {chartConfigs.map(({ id, description , icon, arrow, label, value,color}) => (
        <div key={id} className={styles.card}>
          <div className={styles.header}>
            <KoText className={styles.label} text={label} />
            <KoIcon name={icon} width={25} height={25} color={color?color : '#637381'}/>
           
          </div>
          <div className={styles.mycontent}>
            <div className={styles.count} >
              <KoTitle level={1} className={styles.value} text={value} />
            </div>
            <div className={styles.descriptionBox}>
              <KoText className={arrow ==='ArrowLineUpFilled' ?  styles.success : styles.budget} text='10%' />
              <KoIcon name={arrow} width={16} height={16} />
              <KoText className={styles.description} text={description} />
              
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default CustomerStatus;